// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { apiService } from "../../../services/api/apiService";

export interface BillingApiContext {
  token: string;
}

export interface BillingPortalResult {
  url: string;
}

export async function getBillingPortalUrl(
  context: BillingApiContext,
): Promise<string> {
  const response = await apiService.requestJson<BillingPortalResult>({
    path: "/api/billing/portal",
    method: "POST",
    token: context.token,
  });
  return response.unwrap().url;
}
